module.exports = __webpack_public_path__ + "72959985aed9441fad8627884f810164.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./src/audio/panic.mp3
 ** module id = 648
 ** module chunks = 0
 **/